import styled from 'styled-components'
import {
  inputBorderColor,
  inputBorderRadius,
  inputPaddingTop,
  inputPaddingBottom,
  inputPaddingLeft,
  inputPaddingRight,
} from './variables'

const InputAddonText = styled.span`
  display: flex;
  align-items: center;
  border: 1px solid ${inputBorderColor};
  border-radius: ${inputBorderRadius};
  color: ${({ theme }) => theme.colors.text.dark.secondary};
  background-color: ${({ theme }) => theme.colors.background.light.primary};
  padding: ${inputPaddingTop} ${inputPaddingLeft} ${inputPaddingBottom}
    ${inputPaddingRight};
  font-size: 0.8125rem;
  white-space: nowrap;

  &:first-child {
    border-right: none;
    border-radius: ${inputBorderRadius} 0 0 ${inputBorderRadius};
  }

  &:last-child {
    border-left: none;
    border-radius: 0 ${inputBorderRadius} ${inputBorderRadius} 0;
  }
`

export default InputAddonText
